import React, { useMemo } from 'react';
import { get, map } from 'lodash';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import type { BannerItemsByZoneId, MobileWidgetType } from '../../../types';
import useMobileTopMatch from './useMobileTopMatch';
import MobileTopMatchItem from '../MobileTopMatchItem';
import './mobileTopMatch.scss';

interface Props {
    sport: string;
    zones: BannerItemsByZoneId;
    missingSportEventIds: string[];
    slideWidth: number;
}

const MobileTopMatch: React.FC<Props> = ({
    missingSportEventIds,
    sport,
    zones,
    slideWidth,
}) => {
    useMobileTopMatch({ missingSportEventIds });

    const list = useMemo(
        () =>
            map(zones, (sports, zoneId) => {
                const sportEventIds = get(sports, sport, undefined);

                if (!sportEventIds) return null;

                return (
                    <MobileTopMatchItem
                        key={zoneId}
                        zoneId={zoneId}
                        sportEventIds={sportEventIds}
                        slideWidth={slideWidth}
                    />
                );
            }).filter((i): i is NonNullable<typeof i> => !!i),
        [sport, zones, slideWidth]
    );

    return (
        <TransitionGroup>
            {map(list, (items, index) => (
                <CSSTransition
                    timeout={300}
                    classNames="mobile-top-match"
                    key={index}
                >
                    {items}
                </CSSTransition>
            ))}
        </TransitionGroup>
    );
};

export default React.memo(MobileTopMatch);
